"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var TZ = "Europe/Paris";
  var DAY_NAMES = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

  var dayStart = function dayStart(date) {
    return moment.tz(date, "YYYY-MM-DD", TZ).toDate();
  };

  var Controller = function () {
    /** @ngInject */
    function Controller($scope, $timeout, DepasService, SchedulesService, PlanningCells) {
      _classCallCheck(this, Controller);

      this.$scope = $scope;
      this.$timeout = $timeout;
      this.DepasService = DepasService;
      this.SchedulesService = SchedulesService;
      this.PlanningCells = PlanningCells;
      this.changed = false;
    }

    _createClass(Controller, [{
      key: "$onInit",
      value: function $onInit() {
        var _this = this;

        var params = this.resolve.params;
        this.operator = params.operator;
        this.schedules = params.schedules;
        this.closures = params.closures.slice();
        this.closuresFrom = params.closuresFrom;
        this.showDay(params.date);

        // Échap ou clic à côté après une suppression : on ferme en signalant le changement.
        this.$scope.$on("modal.closing", function (event, reason, closing) {
          if (!closing && _this.changed) {
            event.preventDefault();
            _this.choose(null);
          }
        });
      }
    }, {
      key: "dayTitle",
      value: function dayTitle() {
        var day = moment(this.date, "YYYY-MM-DD");
        return DAY_NAMES[day.isoWeekday() - 1] + " " + day.format("DD/MM");
      }
    }, {
      key: "showDay",
      value: function showDay(date) {
        this.date = date;
        var nextDate = moment(date, "YYYY-MM-DD").add(1, "day").format("YYYY-MM-DD");
        this.entries = this.PlanningCells.buildDayDetail(this.schedules, this.closures, dayStart(date), dayStart(nextDate));
      }

      // Les fermetures ne sont chargées qu'à partir de la semaine du planning : on recharge pour un jour antérieur.

    }, {
      key: "changeDay",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(offset) {
          var date, slots, operatorId;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  date = moment(this.date, "YYYY-MM-DD").add(offset, "day").format("YYYY-MM-DD");

                  if (!(date < this.closuresFrom)) {
                    _context.next = 19;
                    break;
                  }

                  _context.prev = 2;
                  _context.next = 5;
                  return this.SchedulesService.post("mobile/bookedSlots", { start: dayStart(date) });

                case 5:
                  _context.t0 = _context.sent;

                  if (_context.t0) {
                    _context.next = 8;
                    break;
                  }

                  _context.t0 = [];

                case 8:
                  slots = _context.t0;
                  operatorId = (this.operator._id || "").replace(/^\$/, "");

                  this.closures = this.PlanningCells.closuresByOperator(slots)[operatorId] || [];
                  this.closuresFrom = date;
                  _context.next = 19;
                  break;

                case 14:
                  _context.prev = 14;
                  _context.t1 = _context["catch"](2);

                  console.error(_context.t1);
                  Notiflix.Notify.failure("Impossible de charger les fermetures de ce jour.");
                  return _context.abrupt("return");

                case 19:
                  this.showDay(date);
                  this.$timeout(function () {}, 0);

                case 21:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[2, 14]]);
        }));

        function changeDay(_x) {
          return _ref.apply(this, arguments);
        }

        return changeDay;
      }()
    }, {
      key: "operatorName",
      value: function operatorName() {
        return ((this.operator.firstName || "") + " " + (this.operator.lastName || "")).trim();
      }
    }, {
      key: "hour",
      value: function hour(date) {
        return moment(date).tz(TZ).format("HH:mm");
      }
    }, {
      key: "closureLabel",
      value: function closureLabel(entry) {
        return moment(entry.start).tz(TZ).format("DD/MM/YYYY HH:mm") + " au " + moment(entry.end).tz(TZ).format("DD/MM/YYYY HH:mm");
      }

      // Le planning enchaîne sur la fenêtre demandée pour pouvoir recharger ensuite.

    }, {
      key: "choose",
      value: function choose(action, id) {
        this.$scope.$parent.$close({ action: action, id: id, date: this.date, changed: this.changed });
      }
    }, {
      key: "deleteClosure",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(entry) {
          var confirmed;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return swal({
                    title: "Voulez-vous supprimer la période fermée du " + this.closureLabel(entry) + " ?",
                    icon: "warning",
                    dangerMode: true,
                    buttons: ["Annuler", "Valider"]
                  });

                case 2:
                  confirmed = _context2.sent;

                  if (confirmed) {
                    _context2.next = 5;
                    break;
                  }

                  return _context2.abrupt("return");

                case 5:
                  _context2.prev = 5;
                  _context2.next = 8;
                  return this.DepasService.deleteById(entry.id);

                case 8:
                  this.entries.splice(this.entries.indexOf(entry), 1);
                  this.closures = this.closures.filter(function (closure) {
                    return closure.id !== entry.id;
                  });
                  this.changed = true;
                  Notiflix.Notify.success("La suppression a réussi");
                  _context2.next = 18;
                  break;

                case 14:
                  _context2.prev = 14;
                  _context2.t0 = _context2["catch"](5);

                  console.error(_context2.t0);
                  Notiflix.Notify.failure("La suppression a échoué");

                case 18:
                  this.$timeout(function () {}, 0);

                case 19:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[5, 14]]);
        }));

        function deleteClosure(_x2) {
          return _ref2.apply(this, arguments);
        }

        return deleteClosure;
      }()

      // Une plage est une règle récurrente : la supprimer l'enlève de tous les jours.

    }, {
      key: "deleteSchedule",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(entry) {
          var confirmed;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return swal({
                    title: "Voulez-vous supprimer la plage ouverte de " + this.hour(entry.start) + " à " + this.hour(entry.end) + " ?",
                    text: "Elle sera supprimée pour tous les jours où elle s'applique, pas seulement le " + this.dayTitle() + ".",
                    icon: "warning",
                    dangerMode: true,
                    buttons: ["Annuler", "Valider"]
                  });

                case 2:
                  confirmed = _context3.sent;

                  if (confirmed) {
                    _context3.next = 5;
                    break;
                  }

                  return _context3.abrupt("return");

                case 5:
                  _context3.prev = 5;
                  _context3.next = 8;
                  return this.SchedulesService.deleteById(entry.id);

                case 8:
                  this.schedules = this.schedules.filter(function (schedule) {
                    return schedule._id !== entry.id;
                  });
                  this.showDay(this.date);
                  this.changed = true;
                  Notiflix.Notify.success("La suppression a réussi");
                  _context3.next = 18;
                  break;

                case 14:
                  _context3.prev = 14;
                  _context3.t0 = _context3["catch"](5);

                  console.error(_context3.t0);
                  Notiflix.Notify.failure("La suppression a échoué");

                case 18:
                  this.$timeout(function () {}, 0);

                case 19:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[5, 14]]);
        }));

        function deleteSchedule(_x3) {
          return _ref3.apply(this, arguments);
        }

        return deleteSchedule;
      }()
    }, {
      key: "close",
      value: function close() {
        this.$scope.$parent.$dismiss();
      }
    }]);

    return Controller;
  }();

  angular.module("schedules.planning").component("operatorDay", {
    templateUrl: "app/pages/schedules/planning/operatorDay.html",
    bindings: { resolve: "<?" },
    controller: Controller
  });
})();